import { AnswerSummary } from 'cccisd-laravel-appdefs/dist/reportTemplates';
import Step3Comparison from './Step3Comparison';
import Step4Comparison from './Step4Comparison';
import Step5Comparison from './Step5Comparison';

export default [AnswerSummary, Step3Comparison, Step4Comparison, Step5Comparison];
